export const StoreActions = {
    SetFullData: "SetFullData",
    SetSortBy: "SetSortBy",
    ToggleLanguageFilter: "ToggleLanguageFilter",
    ToggleGenreFilter: "ToggleGenreFilter",
    ToggleReleasedMovies: "ToggleReleasedMovies",
    RunTrailer: "RunTrailer",
};

export const SortBy = {
    Popular: "Popular",
    Fresh: "Fresh",
};
